// src/components/ClearDataScreen.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ClearDataScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const boothNameKey = "photobooth_boothName";

    // Retrieve the booth name value
    const boothNameValue = localStorage.getItem(boothNameKey);

    // Clear all local storage
    localStorage.clear();

    // Restore the booth name key-value pair
    if (boothNameValue !== null) {
      localStorage.setItem(boothNameKey, boothNameValue);
    }

    // Redirect to home after clearing data
    setTimeout(() => {
      navigate("/");
    }, 3000); // 3 seconds delay
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center ">
      <h1 className="text-5xl font-bold text-white mb-8">Data Cleared</h1>
      <p className="text-white mb-4 text-lg">
        All local storage data has been cleared except the booth name. You will
        be redirected to the home page shortly.
      </p>
    </div>
  );
};

export default ClearDataScreen;
